import { render, staticRenderFns } from "./ICS.vue?vue&type=template&id=5b4bd5c4&scoped=true"
import script from "./ICS.vue?vue&type=script&lang=js"
export * from "./ICS.vue?vue&type=script&lang=js"
import style0 from "./ICS.vue?vue&type=style&index=0&id=5b4bd5c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4bd5c4",
  null
  
)

export default component.exports